// extracted by mini-css-extract-plugin
module.exports = {"form-group":"jcdubUrzg3vcOLkEyUKiv","menu-title-loyalty-row":"KJv1OPpru70gBivxKz3Ic"};